import { RemovePillData } from '@shared/interfaces';

export class FilterPill {
    isRemovable = true;
    onRemove: (data: RemovePillData) => void = () => null;
    hasOverlay = false;
    values: { label: string; value: number }[] = [];
    isVisible = false;
    label: string;

    constructor(label: string) {
        this.label = label;
    }

    protected updateState(...data: any) {
        data;
    }

    protected getState() {}
}
